import React, { useEffect } from 'react';

import { GeneralModal } from "components";
import { func_validation } from 'functions';

import "assets/scss/components/modals/listBoxTransferModal.scss";
import { ListBoxTransfer } from 'components/form/ListBoxTransfer';


export function ListBoxTransferModal(props) {
    const { 
        isModalVisible,

        title
    } = props;

    return (
        <GeneralModal
            modalWapperClassName={"component-listBoxTransferModal"}
            isModalVisible={isModalVisible}
            updateParentState={props.updateParentState}

            title={title}

            // Header

            headerClassName={"component-listBoxTransferModal-header"}
            headerCloseClassName={"component-listBoxTransferModal-header-close"}

            // Body

            bodyClassName={"component-listBoxTransferModal-body"}
            bodyWrapperClassName={"component-listBoxTransferModal-bodyWrapper"}

            bodyHeaderClassName={"component-listBoxTransferModal-bodyHeader"}
            // bodyHeader={(
            //     <Datepicker
            //         defaultDate={nextBilledDatetime}
            //         handleOnChange={setNextBilledDatetime}
            //         isConversionRequired_ISO8601
            //     />
            // )}

            contentClassName={"component-listBoxTransferModal-bodyContent"}
            content={(
                <ListBoxTransfer
                    {...props}
                />
            )}

            // bodyFooterClassName={"component-listBoxTransferModal-input"}
            // bodyFooter={(

            // )}


            // // Footer
            // footerClassName={"component-listBoxTransferModal-footer"}
            // footerCancelWrapperClassName={"component-listBoxTransferModal-footer-cancelWrapper"}
            // footerCancelClassName={"component-listBoxTransferModal-footer-cancel"}
            // footerConfirmWrapperClassName={"component-listBoxTransferModal-footer-confirmWrapper"}
            // footerConfirmClassName={"component-listBoxTransferModal-footer-confirm"}
            // cancelButtonText={cancelButtonText_validated}
            // handleOnCancel={props.handleOnCancel}
            // isCancelButtonVisible

            // confirmButtonText={confirmButtonText_validated}
            // handleOnConfirm={props.handleOnConfirm}
            // isConfirmButtonVisible
        />
    )
}